import { render, staticRenderFns } from "./DFormPlan.vue?vue&type=template&id=9062270a&scoped=true&"
import script from "./DFormPlan.vue?vue&type=script&lang=js&"
export * from "./DFormPlan.vue?vue&type=script&lang=js&"
import style0 from "./DFormPlan.vue?vue&type=style&index=0&id=9062270a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9062270a",
  null
  
)

export default component.exports